import { i18n } from '../../shared/i18n'
import { readEnv } from '../runtime-env'
import { buildOAuthRedirectUri, startOAuthLoginState } from './oauth-state'

const NAVER_AUTHORIZE_URL = 'https://nid.naver.com/oauth2.0/authorize'

/**
 * Leaves for the Naver login page (개발항목 166). The callback page sends the code to the server,
 * which exchanges it with its own client secret — only the public client ID is in the browser.
 */
export function signInWithNaver(): void {
  const clientId = readEnv('VITE_NAVER_CLIENT_ID')
  if (!clientId) {
    throw new Error(i18n.t('common.errors.authConfigError'))
  }

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    redirect_uri: buildOAuthRedirectUri('NAVER'),
    state: startOAuthLoginState('NAVER'),
  })
  window.location.assign(`${NAVER_AUTHORIZE_URL}?${params.toString()}`)
}
